import { ROUTES } from '../shared/constants'
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined'
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined'
import { VscDashboard } from 'react-icons/vsc'
import { FiTarget } from 'react-icons/fi'
import { FaSuitcaseRolling, FaShieldAlt } from 'react-icons/fa'
import { RiAdminFill } from 'react-icons/ri'
import { FaDollarSign } from 'react-icons/fa'
import { GiTreeGrowth, GiWantedReward } from 'react-icons/gi'
import { AiOutlineAudit } from 'react-icons/ai'
import { SiMarketo } from 'react-icons/si'
import {BsFillArchiveFill} from 'react-icons/bs'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'

export const getMenuItems = (userType, permissions) => {
  // permissions = ["EMPLOYEE", "LEAD", "ORDER"]
  console.log("permissions", permissions.includes('LEAD'));
  let tempUserType = userType === 'SUPERADMIN'
  const superAdmin = [
    // { icon: 'icon', label: 'Dashboard', url: Ro, display: true },
    { icon: FaSuitcaseRolling, label: 'Company', url: ROUTES.ALL_COMPANIES, display: true },
    { icon: RiAdminFill, label: 'Super Admins', url: ROUTES.ALL_SUPERADMINS, display: true },
    { icon: FaDollarSign, label: 'Subscription Plans', url: ROUTES.ALL_SUBSCRIPTION_PLANS, display: true },
    {
      label: 'Active Subscriptions',
      icon: GiWantedReward,
      url: ROUTES.ACTIVE_SUBSCRIPTIONS,
      display: userType === "SUPERADMIN" || permissions.includes('SUPERADMIN'),
    },
    {
      icon: FaShieldAlt,
      label: 'Permissions',
      url: ROUTES.PERMISSIONS,
      display: true,
    },
    // { icon: FaDollarSign, label: 'Subscription Plans', url: ROUTES.ALL_SUBSCRIPTION_PLANS, display: true },
  ]

  const othersMenu = [
    { icon: VscDashboard, label: 'Dashboard', url: '/dashboard', display: userType === 'ALLEMPLOYEE' || tempUserType || userType === "COMPANYADMIN"},
    {
      label: 'Employee',
      icon: PeopleAltOutlinedIcon,
      subMenu: [
        { label: 'All Employees', url: ROUTES.ALL_EMPLOYEES },
        { label: 'Attendance', url: ROUTES.ALL_ATTENDANCE },
        { label: 'Leave Request', url: ROUTES.LEAVE_REQUESTS },
        { label: 'Beat Plan', url: ROUTES.BEAT_PLANS },
        { label: 'Geo Location', url: ROUTES.GEOLOCATION },
        { label: 'Travel & Expense', url: ROUTES.TRAVEL_REQUESTS },
        { label: 'Rewards', url: ROUTES.ALL_REWARD },
      ],
      openNav: 'attendance',
      display: permissions.includes('EMPLOYEE') || tempUserType,
    },
    // { 
    //   icon: DescriptionOutlinedIcon, 
    //   label: 'Beat Plan',
    //   url: ROUTES.BEAT_PLANS,
    //     display:  permissions.includes('BEAT') || tempUserType,
    // },
    // { 
    //   icon: DescriptionOutlinedIcon, 
    //   label: 'Geo Location', 
    //   url: ROUTES.GEOLOCATION,
    //   display: permissions.includes('EMPLOYEE') || permissions.includes('ATTENDANCE')
    // },
    
    {
      label: 'Lead Management',
      icon: PersonOutlinedIcon,
      subMenu: [
        { label: 'Customer', url: ROUTES.CUSTOMERS },
        { label: 'Leads', url: ROUTES.LEADS },
      ],
      openNav: 'lead',
      display: permissions.includes('LEAD') || tempUserType,
    },
    { icon: BsFillArchiveFill, label: 'Order Management', url: ROUTES.MY_TMPORDERS, display: permissions.includes('ORDER') },
    {
      label: 'Sales Management',
      icon: FiTarget,
      subMenu: [
        { label: 'Dashboard', url: ROUTES.SALESDASHBOARD },
        { label: 'Target', url: ROUTES.ALL_TARGETS },
        { label: 'Primary Sales', url: ROUTES.PRIMARY_SALES },
        // { label: 'Sales Return', url: ROUTES.SALES_RETURN },
        { label: 'Achievement', url: ROUTES.ACHIEVEMENT_REPORT },
        { label: 'Incentive', url: ROUTES.INCENTIVE },
      ],
      openNav: 'sales',
      display: permissions.includes('SALES') || tempUserType ,
    },
        
    { icon: DescriptionOutlinedIcon, label: 'Dealer Onboarding', url: ROUTES.DEALER_ONBOARDING, display: permissions.includes('DEALER_ONBOARDING') },
    {
      label: 'Product Management',
      icon: LocalMallOutlinedIcon,
      subMenu: [
        { label: 'Category', url: ROUTES.CATEGORIES },
        { label: 'Sub Category', url: ROUTES.SUBCATEGORIES },
        { label: 'Product', url: ROUTES.PRODUCTS },
        { label: 'Product Catalogue', url: ROUTES.PRODUCT_CATALOGUE },
      ],
      openNav: 'product',
      display: permissions.includes('PRODUCT') || tempUserType,
    },
    {
      label: 'Marketing',
      icon: SiMarketo,
      subMenu: [{ label: 'Pos Task', url: ROUTES.ALL_POS_TASK }],
      openNav: 'marketing',
      display: permissions.includes('AUDIT') || tempUserType,
    },
    {
      label: 'L & D',
      icon: GiTreeGrowth,
      subMenu: [
        { label: 'Training Category', url: ROUTES.ALL_TRAININGCATEGORY },
        { label: 'Content', url: ROUTES.ALL_TRAININGCATEGORYCONTENT },
        { label: 'Assessment', url: ROUTES.ALL_CONTENTQUESTION },
      ],
      openNav: 'learning',
      display: permissions.includes('LEARNING') || tempUserType,
    },
    { icon: AttachMoneyIcon, label: 'Travel & Expense', url: ROUTES.TRAVEL_REQUESTS, display:  permissions.includes('TRAVEL_ALLOWANCE') || tempUserType },

    {
      label: 'Audit',
      icon: AiOutlineAudit,
      subMenu: [
        { label: 'Dashboard', url: ROUTES.AUDIT_DASHBOARD },
        { label: 'Questions', url: ROUTES.ALL_AUDITQUESTION },
        { label: 'Task Master', url: ROUTES.ALL_TASK },
        { label: 'Audit Upload', url: ROUTES.ALL_AUDITSCORE },
        { label: 'Audit Task', url: ROUTES.ALL_AUDIT_TASK },
      ],
      openNav: 'audit',
      display: permissions.includes('AUDIT') || tempUserType,
    },
    { icon: DescriptionOutlinedIcon, label: 'Reports', url: ROUTES.REPORTS, display: true },
    { icon: DescriptionOutlinedIcon, label: 'Upload Status', url: ROUTES.UPLOAD_STATUS, display: true },
    // {
    //   label: 'Reward',
    //   icon: GiWantedReward,
    //   url: ROUTES.ALL_REWARD,
    //   display: permissions.includes('AUDIT') || tempUserType,
    // },
    // {
    //   label: 'Subscriptions',
    //   icon: FaDollarSign,
    //   url: ROUTES.ALL_SUBSCRIPTION_PLANS,
    //   display: permissions.includes('COMPANYADMIN') || userType === 'COMPANYADMIN' || tempUserType, 
    // },
   
  ]

  return userType !== 'SUPERADMIN' ? othersMenu : superAdmin
}
